<template>
	<div class="text-center">
		<h1 class="h1 font-weight-bold d-none d-lg-block">{{ $t('Kedvencek') }}</h1>
        <div class="h2 text-left d-block d-lg-none">{{$t('Kedvencek')}}</div>

        <div v-if="loading">
            <content-loader
                    :width="730"
                    :height="694"
                    :speed="2"
                    primaryColor="#ffffff"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="6" ry="6" width="730" height="78" /> 
                    <rect x="0" y="88" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="176" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="264" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="352" rx="6" ry="6" width="730" height="78" />
            </content-loader>
        </div>
        <div class="shadow-block text-center font-weight-bold" v-if="!loading && !favorites.length">
            {{$t('Önnek még nincs kedvenc útvonala')}}
        </div>
        <div v-else>
            <div class="shadow-block shadow-block--with-buttons mb-4" v-for="(fav, key) in favorites" :key="key">
                <div class="form-row align-items-center">
                    <div class="shadow-block__pin col-auto py-2">
                        <inline-svg :src="require('@/assets/icons/pin-filled.svg')"></inline-svg>
                    </div>
                    <div class="col-auto py-2">
                        <RouteBadge
                            v-if="fav.route"
                            :route-id="fav.route.routeId"
                            :route-name="fav.route.routeShortName"
                            :route-color="fav.route.routeColor"
                            :route-text-color="fav.route.routeTextColor"
                            small
                        />
                    </div>
                    <div class="col text-left py-2">
                        <div class="text-bigger text-ellipsis d-flex align-items-center" v-if="fav.fromStop || fav.toStop"><template v-if="fav.fromStop">{{fav.fromStop.name}}</template> <template v-if="fav.toStop"><inline-svg class="routes__direction-icon mx-2 shadow-block__pin" :src="require('@/assets/icons/direction-right.svg')" ></inline-svg> {{fav.toStop.name}}</template></div>
                    </div>
                    <div class="col-auto text-right">
                        <button @click="$router.push({name: 'demand-request-process', params: {routeId: fav.route.routeId}, query: {directionId: fav.directionId, fromStop: fav.fromStop.stopId, toStop: fav.toStop.stopId}})" class="button button--small button--blue px-4">{{$t('Igénylés')}}</button>
                    </div>
                    <div class="shadow-block__buttons">
                        <button class="shadow-block__button h-100" @click="removeFromFavorites(fav)" :aria-label="$t('Kedvenc')">
                            <inline-svg :src="require('@/assets/icons/favourite-filled.svg')"></inline-svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import {setRequestFavoriteUsingPUT, getUserFavoriteRequestsUsingGET} from '@/api'
import RouteBadge from '@/components/RouteBadge.vue';
export default {
	name: "Favourites",
	components: {
		RouteBadge
	},
	data() {
		return {
            loading: true,
            favorites: []
        };
	},
	methods: {
		removeFromFavorites: function (item) {
			this.$swal({
				title: this.$t("Eltávolítás"),
				text: this.$t("Biztosan eltávolítod a kedvencek közül?"),
                imageUrl: window.swalInfo,
                confirmButtonText: this.$t('Törlés'),
                cancelButtonText: this.$t('Mégse'),
                showCancelButton: true,
                customClass: {
                    confirmButton: 'button button--blue button--swal',
                    cancelButton: 'button button--swal',
                    title: 'text-biggest font-weight-bold',
                    actions: 'swal2-confirm-actions'
                }
			}).then((result)=> {
                if(result.value) {
                    setRequestFavoriteUsingPUT({demandRequestFavoriteVm: {favorite: false, demandRequestId: item.id}}).then((response) => {
                        if(response.status === 200) {
                            this.favorites = this.favorites.filter((e) => e.id !== item.id);
                        }
                    }).catch(err => {
                        this.$swal({
                            title: this.$t("Eltávolítás"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
                    })
                }
            });
		},
    },
    created() {
        getUserFavoriteRequestsUsingGET().then(response => {
            this.favorites = response.data.content;
        }).catch(err => {
            this.$swal({
				title: this.$t("Kedvencek"),
				text: this.$t("Nem sikerült betöltenünk a kedvenceket. Próbálja meg újratölteni az oldalt."),
                imageUrl: window.swalError
			});
        }).finally(() => {
            this.loading = false;
        });
    }
};
</script>